import React from 'react'
import s from './teacher-stat.module.scss'
import { getCDNPath } from '@utils/lib/getCDNpath'
import { getNoun } from '@utils/lib/getNoun'

export const TeacherStat = ({teacher}) => {
	return (
		<div className={s.wrapper}>
			<div className={s.statsWrapper}>
				<div className={s.statBlock}>
					<img className={s.statIcon}  alt='' src={getCDNPath("images/teacher-page/stars.png")}/>
					<p className={s.statValue}>{teacher?.feedbacks_summary?.confidence_rating?.toFixed(1)}</p>
					<span className={s.statLabel}>Уверенность</span>
				</div>
				<div className={s.statBlock}>
					<img className={s.statIcon}  alt='' src={getCDNPath("images/teacher-page/user-music.png")}/>
					<p className={s.statValue}>{teacher?.feedbacks_summary?.clarity_rating?.toFixed(1)}</p>
					<span className={s.statLabel}>Ясность</span>
				</div>
				<div className={s.statBlock}>
					<img className={s.statIcon}  alt='' src={getCDNPath("images/teacher-page/disk-music.png")}/>
					<p className={s.statValue}>{teacher?.feedbacks_summary?.process_rating?.toFixed(1)}</p>
					<span className={s.statLabel}>Процесс</span>
				</div>
				<div className={s.statBlock}>
					<img className={s.statIcon}  alt='' src={getCDNPath("images/teacher-page/music.png")}/>
					<p className={s.statValue}>{teacher?.feedbacks_summary?.preparation_rating?.toFixed(1)}</p>
					<span className={s.statLabel}>Подготовка</span>
				</div>
			</div>
			{teacher?.feedbacks_summary?.count > 0 && <span className={s.caption}>Основано на {teacher?.feedbacks_summary?.count} {getNoun(teacher?.feedbacks_summary?.count, "анонимой анкете студента", "анонимных анкетах студентов", "анонимных анкетах студентов")}</span>}
		</div>
	)
}
